import React from 'react';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';

interface Props {
  state: [string, React.Dispatch<React.SetStateAction<string>>];
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  error?: boolean;
  pattern?: (value: string) => string;
  onBlur?: () => any;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export function Input({
  state: [text, setText],
  label,
  placeholder,
  disabled = false,
  style = {},
  error,
  pattern,
  onBlur,
  startIcon,
  endIcon,
}: Props): JSX.Element {
  const onSetText = (value: string) => {
    const isPatternRegex = pattern instanceof RegExp;
    if (pattern && !isPatternRegex) {
      // deepcode ignore reDOS: <Uma expressão regular não entrará no IF>
      const newValue = pattern(value);
      setText(newValue);
      return;
    }
    setText(value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
      {label && <label style={{ margin: 0, color: '#6D6D6D', fontSize: 14, fontWeight: 600 }}>{label}</label>}
      <TextField
        value={text}
        onChange={(e: any) => onSetText(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        onBlur={onBlur}
        size="small"
        error={error}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          style: {
            ...style,
          },
          startAdornment: startIcon ? <InputAdornment position="start">{startIcon}</InputAdornment> : null,
          endAdornment: endIcon ? <InputAdornment position="end">{endIcon}</InputAdornment> : null,
        }}
      />
    </div>
  );
}
